import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input} from '@progress/kendo-react-inputs';
import {DropDownList } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import ReactFileReader from 'react-file-reader';
import { Switch } from '@progress/kendo-react-inputs';
import '@progress/kendo-react-common'
import '@progress/kendo-date-math'
import './ManageOrders.scss';
import {
	fetchOrderDetails,
} from '../../../../../Redux/Actions/Admin/ManageOrderAction';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth} from '../../../../../services';
import axios from 'axios';

class OrderManagementForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			orderInEdit: this.props.dataItem || null,			
            value: [],
        };
    };
    componentDidMount() {
		{console.log(this.state.orderInEdit,"order management")}
		var url = `${ROOT_API_URL}/ManageOrder/GetOrderDetails?orderId=${this.state.orderInEdit.OrderId}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((res) => {
				this.setState({
					orderInEdit: res.data
				})
			})
		//this.props.fetchOrderDetails(this.state.orderInEdit.orderId);
    }

	handleSubmit = (event) => {
		event.preventDefault();
		this.props.updateOrder({
			...this.state.orderInEdit
        });
        this.props.cancel();
	}

	onDialogInputChange = (e, i) => {
		let itemCopy = Object.assign({}, this.state);
		itemCopy.orderInEdit.productInvoiceLineItems[i].isFulfilled = e.target.value;
		
		this.setState({ 
			itemCopy	 
		});
	};
 
	render() {
		const productDisplay = this.state.orderInEdit.productInvoiceLineItems ? this.state.orderInEdit.productInvoiceLineItems.map((item, i) => {
			return (
                <li className="row listRow">
                    <div className="col-md-1">
                        <p>{item.quantity}</p>
                    </div>
                    <div className="col-md-4">
                        <p>{item.name}</p>
                    </div>
                    <div className="col-md-2">
                        <p>{item.size ? item.size : "N/A"}</p>
                    </div>
                    <div className="col-md-2">
                        <p>{item.color ? item.color : "N/A"}</p>
                    </div>
                    <div className="col-md-3">
                        <Switch
                            filter="boolean"
                            onChange={(event) => this.onDialogInputChange(event, i)}
                            onLabel={'Shipped'}
                            offLabel={'Pending'}
                            checked={item.isFulfilled}
                            value={item.isFulfilled || ''}
                            name="isFulfilled"
                            id="isFulfilled"
                        />
                    </div>
                </li>
			);
		}):"";
		return (
		<div className="eventDialog">
            <div>
				{<h2 className="adjust-header">Order Details</h2>}    
				<form className="user-form ordersForm" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-12">
						<label htmlFor="title" className="title">Order Number: <span>{this.state.orderInEdit.orderNumber}</span></label>
					</div>
                    <div className="form-group col-md-12">
                        <label htmlFor="title" className="title">Shipping Address: <span>{this.state.orderInEdit.address}</span></label>
                    </div>
					<div className="form-group col-md-12">
                        <ul className="list-group list-group-flush dashboard-info-list">
                            <li className="row headerRow">
                                <div className="col-md-1">
                                    <p>Quantity</p>
                                </div>
                                <div className="col-md-4">
                                    <p>Name</p>
                                </div>
                                <div className="col-md-2">
                                    <p>Size</p>
                                </div>
                                <div className="col-md-2">
                                    <p>Color</p>
                                </div>
                                <div className="col-md-3">
                                    <p>Is Shipped?</p>
                                </div>
                            </li>
                            {productDisplay}
                        </ul>
					</div>
					<div className="form-group col-md-12 right">
							<label htmlFor="title">Total Amount: <span>${Number(this.state.orderInEdit.subTotal).toFixed(2)}</span></label>
					</div>
					<div className="form-group col-md-12 right">
							<label htmlFor="title">Tax: <span>${Number(this.state.orderInEdit.tax).toFixed(2)}</span></label>
					</div>
					<div className="form-group col-md-12 right">
							<label htmlFor="title">Shipping: <span>${Number(this.state.orderInEdit.shipping).toFixed(2)}</span></label>
					</div>
					<div className="form-group col-md-12 right">
							<label htmlFor="title">Grand Total: <span>${Number(this.state.orderInEdit.grandTotal).toFixed(2)}</span></label>
					</div>
					<DialogActionsBar>
						<div className="footer">
							<div className="form-group">
								<button className="admin-k-button" type="button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								<button type = "submit" className="admin-k-button">
									<i className="fas fa-save"></i>
									<span>SAVE</span>
								</button>
							</div>
						</div>
					</DialogActionsBar>
				</form>
			</div>
		</div>
		);
	}
 }
 function mapStateToProps(state) {
	return {
		common: state.common,
		order:state.order
	};
}

export default connect(mapStateToProps, {fetchOrderDetails,auth})(OrderManagementForm);
